import { Route, Redirect } from 'react-router-dom';

const ProtectedRoute = (props) => {
  return (
    <Route
        {...props}
        render={() => props.isAuth ? <props.componentArg /> : <Redirect to="/dashboard/restricted"/> }
    />
  );
};

export default ProtectedRoute;